// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td.ui-table-row-column{overflow:visible;white-space:normal;width:25%}.ui-table-body .ui-table-row .no-cases{padding:1.5rem;width:300%}.ui-table-body .ui-table-row .no-cases .no-cases-content{text-align:center;text-transform:none;background-size:30px 30px}", ""]);
// Exports
module.exports = exports;
